import { create } from "zustand";

export const useUserStore = create((set) => ({
  userInfo: {},
  userModulesCount: {},

  setUser: (newUserInfo) => {
    set((state) => ({
      ...state,
      userInfo: newUserInfo,
    }));
  },
  setUserModulesCount: (newUserModulesCount) => {
    set((state) => ({
      ...state,
      userModulesCount: newUserModulesCount,
    }));
  },
}));
